export const isString = (string: any) => typeof string === 'string'

export const truncate = (text: string, numberOfWords: number) => {
  return text.split(' ').splice(0, numberOfWords).join(' ').concat('...')
}
